const KEY = 'z2l:viewer';
let fallback: string | null = null;

/**
 * Random id this browser keeps, so the view count counts a person once per stream however often
 * they reload or reconnect. It identifies nothing else and is never tied to an account.
 */
export function viewerId(): string {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved && /^[A-Za-z0-9_-]{8,64}$/.test(saved)) return saved;
    const id = crypto.randomUUID().replace(/-/g, '');
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    // Storage blocked (private mode): one id for this page load.
    return (fallback ??= crypto.randomUUID().replace(/-/g, ''));
  }
}
